// MWC Watch Detail - Utility helpers
// Shared helpers for watch detail modules, such as watch ID lookup, empty state rendering and photo parsing.

(function () {
  window.MWCWatchDetailUtils = {
    getWatchId: getWatchId,
    renderEmpty: renderEmpty,
    parsePhotos: parsePhotos
  };

  function getWatchId() {
    const params = new URLSearchParams(window.location.search);
    return params.get("id");
  }

  function renderEmpty(message) {
    const selectors =
      (window.MWCWatchDetailConstants &&
        window.MWCWatchDetailConstants.selectors) ||
      {};

    const root = document.querySelector(selectors.root || "#mwc-watch-detail");
    if (!root) return;

    root.innerHTML =
      '<div class="text-xs text-subdued">' +
      (message || "Watch not found.") +
      "</div>";
  }

  function parsePhotos(value) {
    let photos = [];

    try {
      photos = JSON.parse(value || "[]");
    } catch (error) {
      console.error("Invalid photos JSON", error);
      return [];
    }

    if (!Array.isArray(photos)) {
      return [];
    }

    return photos.filter(Boolean).slice(0, 5);
  }

})();